import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { ILinkProps } from "../props/ILinkProps";
import Styles from "./NSLink.module.css";

export interface NSLinkProps extends ILinkProps, IBaseComponentProps
{
}

export function NSLink(props: NSLinkProps)
{
	return (
		<div
			id={props.id}
			className={`${Styles.ns_link_parent} ${props.classList?.join(" ") ?? ""}`}
		>
			<a
				className={`text-white text-decoration-none ${props.title ? Styles.ns_link : Styles.ns_link_absolute}`}
				href={props.href}
				target={props?.target ?? "_self"}
				style={props.style}
			>
				{props.title}
			</a>
		</div>
	);
}